import { render } from "./Theatre.vue?vue&type=template&id=6f97d0fa"
import script from "./Theatre.vue?vue&type=script&lang=js"
export * from "./Theatre.vue?vue&type=script&lang=js"

import exportComponent from "/Users/n0m4dz/workspace/projects/seeroo-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__